/**
 * Default export.
 *
 * @param Vue
 */
export default (Vue) => {
  Vue.component('f-select-professional', () => import('./select-professional'))
  Vue.component('f-select-speciality', () => import('./select-speciality'))
  Vue.component('f-select-plan', () => import('./select-plan'))
  Vue.component('f-select-dependent', () => import('./select-dependent'))
  Vue.component('f-select-patient', () => import('./select-patient'))
  Vue.component('f-select-address', () => import('./select-address'))
  Vue.component('f-select-kinship', () => import('./select-kinship'))
}



// WEBPACK FOOTER //
// ./src/components/form/fields/patient/index.js